import * as React from 'react';

import { mergeStyles } from '@cian/utils';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';

import { trackScrollInformation } from '../../tracking';
import { ACTION_AFTER_VIEWED_TIMEOUT } from '../../../../constants/actionAfterViewed';

import * as styles from './styles.css';

export interface IWhyTrustItem {
  className: string;
  title: string;
  text: string;
}

const howItWorksContent = [
  'Вы вводите адрес и параметры квартиры',
  'Мы подбираем объявления и сделки аналогичных квартир',
  'Алгоритмы ИИ вносят поправки к оценке',
  'Формируем отчет рыночной стоимости квартиры',
];

const whyTrustContent = [
  {
    className: 'icon-realythesame',
    title: 'Учитываем только аналогичные квартиры',
    /* eslint-disable */
    text:
      'На цену квартиры влияют десятки параметров, в том числе характеристики дома (расположение, год постройки, тип стен и т.д.), характеристики квартиры (этаж, количество комнат, тип ремонта и т.д.) и многое другое. Для оценки выбираем квартиры с максимально похожими параметрами',
    /* eslint-enable */
  },
  {
    className: 'icon-maxmin',
    title: 'Высокая точность оценки',
    /* eslint-disable */
    text:
      'Оценка Циан – это не агрегированная информация о цене в объявлениях или цене в договорах купли-продажи. Мы используем алгоритмы искусственного интеллекта с  множеством поправочных коэффициентов, что позволяет избежать завышения и занижения цены',
    /* eslint-enable */
  },
  {
    className: 'icon-bigbase',
    title: 'База 2,5 млн. объявлений и сделок',
    /* eslint-disable */
    text:
      'У нас одна из самых больших баз объявлений и сделок. Учитываем динамику спроса и предложения и данные о рыночных сделках',
    /* eslint-enable */
  },
  {
    className: 'icon-smallth',
    title: 'Внимание к деталям',
    text: 'Получайте более точную оценку, указав тип ремонта, вид из окон, срочность продажи и другие параметры',
  },
];

export function howItWorksRenderRow(text: string, index: number) {
  return (
    <div key={index} className={styles['list-item']}>
      <span>{index + 1}</span>
      <span>{text}</span>
    </div>
  );
}

export function whyTrustRenderItems(items: IWhyTrustItem[]) {
  return items.map((item, index) => {
    const { className, title, text } = item;

    return (
      <div key={index} className={styles['why-trust-item']}>
        <div {...mergeStyles(styles['icon-box'], styles[className])} />
        <div className={styles['subtitle']}>{title}</div>
        <div className={styles['description']}>{text}</div>
      </div>
    );
  });
}

export function Valuation() {
  return (
    <div className={styles['container']}>
      <ActionAfterViewed
        timeoutCallback={ACTION_AFTER_VIEWED_TIMEOUT}
        callback={() => trackScrollInformation('HowItWorks')}
      >
        <div className={styles['how-works']}>
          <div className={styles['title']}>Как работает оценка Циан</div>
          <div className={styles['list']}>{howItWorksContent.map(howItWorksRenderRow)}</div>
        </div>
      </ActionAfterViewed>

      <ActionAfterViewed
        timeoutCallback={ACTION_AFTER_VIEWED_TIMEOUT}
        callback={() => trackScrollInformation('Reasons')}
      >
        <div className={styles['why-trust']}>
          <div className={styles['title']}>Почему стоит доверять оценке Циан</div>
          {whyTrustRenderItems(whyTrustContent)}
        </div>
      </ActionAfterViewed>
    </div>
  );
}
